import type { ReactNode, ComponentProps } from 'react';
import React, { createContext, useContext } from 'react';
import { I18nextProvider, Translation } from 'react-i18next';
import { i18nInit } from '../../i18n';
import type { TFunction } from 'i18next';
import type Experiments from '@wix/wix-experiments';

const TranslationContext = createContext<TFunction | undefined>(undefined);

export function TranslationProvider(props: {
  children: ReactNode;
  locale?: string;
  baseUrl?: string;
  experiments?: Experiments;
  i18n?: ComponentProps<typeof I18nextProvider>['i18n'];
}) {
  const { children, locale, experiments, baseUrl } = props;
  const i18n = props.i18n ?? i18nInit({ locale, experiments, baseUrl });
  return (
    <I18nextProvider i18n={i18n}>
      <Translation>
        {(t) => (
          <TranslationContext.Provider value={t}>
            {children}
          </TranslationContext.Provider>
        )}
      </Translation>
    </I18nextProvider>
  );
}

export function useTranslation() {
  const context = useContext(TranslationContext);

  if (!context) {
    throw new Error(
      'useTranslation should be used inside a TranslationProvider',
    );
  }

  return context;
}
